export default __webpack_public_path__ + "static/media/soraImage2.08fda069.jpg";